export enum LogisticOperatorStatus {
  CREATED = 'CREATED',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export const LogisticOperatorStatusLabels: Record<
  LogisticOperatorStatus,
  string
> = {
  [LogisticOperatorStatus.CREATED]: 'Creado',
  [LogisticOperatorStatus.ACTIVE]: 'Activo',
  [LogisticOperatorStatus.INACTIVE]: 'Inactivo',
};
